$(() => {
  const isInModal = (element) => element && element.closest && element.closest("#hx-modal");
  const hxModal = document.getElementById("hx-modal");

  document.addEventListener("htmx:afterSwap", (e) => {
    if (isInModal(e.target)) $(hxModal).modal("show");
  });

  document.addEventListener("htmx:beforeCleanupElement", (e) => {
    if (isInModal(e.target)) $(hxModal).modal("hide");
  });
});

document.addEventListener("htmx:beforeCleanupElement", (e) => {
  if (!e.originalEvent) return;
  let detail = e.originalEvent.detail;
  if (detail.elt instanceof HTMLSelectElement) {
    try {
      $(detail.elt).select2("destroy");
    } catch (error) {}
  }
});

document.addEventListener("htmx:afterSettle", (e) => {
  for (let el of e.target.querySelectorAll("select.auto-select2")) {
    $(el).select2({});
    $(el).on("select2:select", (e) => {
      e.currentTarget.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
});

Shared = new (function () {
  this.bindEvents = () => {
    $(".confirm-delete").on("click", ".btn-ok", function (e) {
      var link = $(this).data("link");
      var checkBoxValue = $(".confirm-delete input[name='confirm_delete_checkbox']").is(":checked");

      $.ajax({
        type: "DELETE",
        url: link,
        data: JSON.stringify({ delete_permanently: checkBoxValue }),
        contentType: "application/json",
        dataType: "json",
        success: function () {
          location.reload();
        },
        error: function () {
          location.reload();
        },
      });
    });

    $(".confirm-delete").on("show.bs.modal", function (e) {
      var data = $(e.relatedTarget).data();
      var link = $(e.relatedTarget).attr("href");

      $(".title", this).text(data.recordTitle);
      $(".btn-ok", this).data("link", link);
    });
  };

  this.showSnackbar = ({ type = CONSTANTS.ALERT_TYPES.success, ...props }) => {
    const className = {
      error: "alert-danger",
      success: "alert-success",
      warning: "alert-warning",
      info: "alert-info",
    }[type];

    const snackbar = `
      <div x-cloak
        x-data="{open: false}"
        x-init.1="await $nextTick(); open = true; "
        x-init.2="setTimeout(() => $el.remove(), 5000)"
        x-init.3="setTimeout(() => { open = false }, 4500)"
        x-show="open"
        x-transition
      >
        <div class="alert ${className} t:flex t:items-center" role="alert">
          <span>${props.text}</span>
          <button type="button" class="t:ml-4 close" @click="open = false" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    `;
    document.querySelector("#toast-container").insertAdjacentHTML("beforeend", snackbar);
  };

  /**
   * Customizable function to draw student result chart
   *
   * @param {Object} props All parameters
   * @param {array} props.objects All the data table to show in chart
   * @param {boolean} props.isSubjectsShown Returns true if including subject name on axis
   * @param {string} props.containerElementId The element to show chart in that
   * @param {string} props.legendElementId The corresponding legend for the containerElement with default set to student-dashboard.
   * @param {Object} props.options the Options to override on default chart options.
   * @returns {void} Nothing
   */
  this.drawStudentChart = (props) => {
    const {
      objects,
      isSubjectsShown,
      containerElementId,
      legendElementId = "chart-legend",
      options: customOptions = {},
    } = props;

    let dataSubject = [["Year", "Actual result", "Expected result", "Target result", "min"]];
    let scoreLevels = [];
    let targetObjects = objects.filter((v) => Number.isInteger(v.max_target));
    let isScoreLevelPresent = objects.find((v) => v.score_level);
    if (targetObjects.length) {
      for (let i = 0; i < objects.length; i++) {
        dataSubject.push([
          buildGraphTitle(objects[i]),
          parseInt(objects[i].valuation),
          parseInt(objects[i].expectation),
          parseInt(objects[i].max_target),
          parseInt(objects[i].min_target),
        ]);
      }
    } else {
      dataSubject = [["Year", "Actual result", "Expected result"]];

      for (let i = 0; i < objects.length; i++) {
        dataSubject.push([
          buildGraphTitle(objects[i]),
          parseInt(objects[i].valuation),
          parseInt(objects[i].expectation),
        ]);
      }
    }
    if (isScoreLevelPresent) {
      for (let i = 0; i < objects.length; i++) {
        scoreLevels.push(objects[i].score_level);
      }
    }

    function buildGraphTitle(value) {
      return isSubjectsShown
        ? `${ordinal(value.student_year.academical_year)} Year ${value.title} ${value.subject}`
        : `${ordinal(value.student_year.academical_year)} Year ${value.title}`;
    }

    google.charts.load("current", { packages: ["corechart"] });
    google.charts.setOnLoadCallback(drawChart);

    function drawChart() {
      const data = google.visualization.arrayToDataTable(dataSubject);

      const options = {
        chartArea: {
          left: GRAPH_CONSTANTS.dimensions.left,
          top: GRAPH_CONSTANTS.dimensions.top,
          width: "90%",
          height: "75%",
        },
        hAxis: {
          textStyle: {
            fontSize: GRAPH_CONSTANTS.dimensions.fontSize,
          },
          gridlines: { color: "none", count: 0 },
        },
        vAxis: {
          maxValue: GRAPH_CONSTANTS.MAX_RESULT,
          minValue: GRAPH_CONSTANTS.MIN_RESULT,
          gridlines: { color: "none", count: 0 },
        },
        legend: { position: "none" },
        pointSize: 3.5,
        lineWidth: 2,
        series: {
          1: {
            areaOpacity: 2,
            lineDashStyle: [2, 2],
          },
          2: {
            pointSize: 0,
            lineWidth: 0,
            enableInteractivity: false,
          },
          3: {
            pointSize: 0,
            lineWidth: 0,
            visibleInLegend: false,
            enableInteractivity: false,
          },
        },
        height: GRAPH_CONSTANTS.dimensions.height,
        colors: Object.values(GRAPH_CONSTANTS.colors),
        ...customOptions,
      };

      const container = document.getElementById(containerElementId);
      const chart = new google.visualization.AreaChart(container);

      google.visualization.events.addListener(chart, "ready", function () {
        setPointColor();
        const observer = new MutationObserver(function () {
          Array.prototype.forEach.call(container.getElementsByTagName("path"), function (rect) {
            const fillColor = rect.getAttribute("fill");

            switch (fillColor) {
              case GRAPH_CONSTANTS.colors.expectedResult:
                return drawGradientArea(rect, GRAPH_CONSTANTS.paths.expected);

              case GRAPH_CONSTANTS.colors.actualResult:
                return drawGradientArea(rect, GRAPH_CONSTANTS.paths.actual);

              case GRAPH_CONSTANTS.colors.targetResult:
                return drawTargetRectangle(rect);
            }
          });
        });
        observer.observe(container, {
          childList: true,
          subtree: true,
        });
        setLabelFontWeight();
        setScoreLevels(scoreLevels);
        if (targetObjects.length === 1) {
          drawSingleResultTargetRectangle(targetObjects[0], container.querySelector("svg").children[2]);
        }
      });
      showLegend();
      chart.draw(data, options);

      google.visualization.events.addListener(chart, "onmouseover", setPointColor);
      google.visualization.events.addListener(chart, "onmouseout", setPointColor);
    }

    function showLegend() {
      if (scoreLevels.length > 0) {
        $(
          `#${legendElementId} div[data-level='H'], #${legendElementId} div[data-level='O'], #${legendElementId} div[data-level='F']`
        )
          .removeClass("t:flex")
          .hide();

        let legend /* HTMLDivElement */ = document.getElementById(legendElementId);
        legend.removeAttribute("data-has-h");
        legend.removeAttribute("data-has-o");
        legend.removeAttribute("data-has-f");

        if (scoreLevels.includes("H")) {
          $(`#${legendElementId} div[data-level='H']`).addClass("t:flex").show();
          legend.setAttribute("data-has-h", '');
        }
        if (scoreLevels.includes("O")) {
          $(`#${legendElementId} div[data-level='O']`).addClass("t:flex").show();
          legend.setAttribute("data-has-o", '');
        }
        if (scoreLevels.includes("F")) {
          $(`#${legendElementId} div[data-level='F']`).addClass("t:flex").show();
          legend.setAttribute("data-has-f", '');
        }
      }
    }

    function setLabelFontWeight() {
      let labels = $(`#${containerElementId} svg > g:eq(1) > g:eq(2) > g`);
      for (let i = 0; i < labels.length; i++) {
        const children = labels[i].children;
        if (children.length > 1) {
          labels[i].children[0].setAttribute("font-weight", "Bold");
        }
      }
    }

    function setPointColor() {
      const circles = $(`#${containerElementId} svg circle`);
      let hex, radius;

      for (circle of circles) {
        hex = circle.getAttribute("fill");
        radius = circle.getAttribute("r");
        if (hex !== GRAPH_CONSTANTS.colors.white && radius == GRAPH_CONSTANTS.dimensions.radius) {
          circle.setAttribute("stroke", hex);
          circle.setAttribute("stroke-width", GRAPH_CONSTANTS.dimensions.sWidth);
          circle.setAttribute("fill", GRAPH_CONSTANTS.colors.white);
        }
      }
    }

    function setScoreLevels(scoreLevels) {
      let actualPlots = $(`#${containerElementId} svg:eq(0) >g:eq(0)>g:eq(1) circle`);

      const ChangePointStyle = (currentPoint, type) => {
        const template = document.querySelector(`#Actual-Result-${type}`);
        if (!template) return;
        const clonedTemplate = template.cloneNode(true);
        const point = utils.makeSVG("g", { "data-level": type });
        Array.from(clonedTemplate.children).forEach((circle) => {
          circle.setAttribute("cx", currentPoint.getAttribute("cx"));
          circle.setAttribute("cy", currentPoint.getAttribute("cy"));
          point.append(circle);
        });
        return point;
      };

      // Change point styles of actual results based on score level
      for (let i = 0; i < actualPlots.length; i++) {
        if (actualPlots[i].getAttribute("stroke") == GRAPH_CONSTANTS.colors.actualResult) {
          actualPlots[i].before(ChangePointStyle(actualPlots[i], scoreLevels[i]));
        }
      }
    }

    /**
     * fill passed path(rect) with related gradient element in html file
     *
     * @param {PathElement} rect
     * @param {string} pathName expected | actual
     * @return {PathElement}
     */
    function drawGradientArea(rect, pathName) {
      rect.setAttribute("fill", `url('#${pathName}ResultGradient')`);
    }

    function drawTargetRectangle(rect) {
      /**
       * Convert string svg d to array of paths
       * @param {string} paths
       * @returns {array} [[x1,y2],[x2,y2],...]
       */
      const convertPathsToArray = (paths) => paths.replace(/M|Z/g, "").split("L");

      /**
       * find rectangle coordinates of the path element
       *
       * @param {PathElement} pathD
       * @returns {object} {x1:x-coordinate, y1:y-coordinate, x2:width, y2:height}
       */
      const getRectangleCoors = (pathD) => {
        const coords = convertPathsToArray(pathD);
        const xCoors = coords.map((xy) => xy.split(",")[0]);
        const yCoors = coords.map((xy) => xy.split(",")[1]);
        return {
          x1: GRAPH_CONSTANTS.dimensions.left,
          y1: Math.max(...yCoors),
          x2: Math.max(...xCoors),
          y2: Math.min(...yCoors),
        };
      };

      /**
       * draw a rectangle based on 3nd and 4nd series in the chart to show target result
       *
       * @param {object} coors1 coordinates of 3nd series
       * @param {object} coors2 coordinates of 3nd series
       * @returns {ElementPath} a rectangle in chart
       */
      const drawRectangle = (coors1, coors2) => {
        const height = parseFloat(coors2["y2"]) - parseFloat(coors1["y2"]);
        const width = parseFloat(coors1["x2"]) - parseFloat(coors1["x1"]);
        const xCoor = parseFloat(coors1["x1"]);
        const yCoor = parseFloat(coors1["y2"]);
        const coors = [xCoor, yCoor, width, height];
        const newRect = utils.makeSVG("rect", {
          x: coors[0],
          y: coors[1],
          width: coors[2],
          height: coors[3],
          stroke: "none",
          "fill-opacity": 1,
          fill: `url('#targetResultPattern')`,
        });
        return newRect;
      };

      // extract path and coors from series (area) 3,4
      const blueBlock = rect;
      const whiteBlock = rect.parentElement.nextSibling.children[0];
      const blueCoors = getRectangleCoors(blueBlock.getAttribute("d"));
      const whiteCoors = getRectangleCoors(whiteBlock.getAttribute("d"));
      // create and add new rectangle
      const newRect = drawRectangle(blueCoors, whiteCoors);
      rect.parentElement.appendChild(newRect);
      //remove old areas
      blueBlock.remove();
      whiteBlock.parentElement.remove();
    }

    /**
     * create a target result rectangle if only one result present, and target exists
     * @param {object} result an object containing results data
     * @param {HTMLElement} graphEl a SVG element that represents the created graph
     */
    function drawSingleResultTargetRectangle(result, graphEl) {
      const rectHeight = (result.max_target - result.min_target) * GRAPH_CONSTANTS.dimensions.scale;
      const rectWidth = parseInt(graphEl.children[0].getAttribute("width"));
      const startingY =
        (GRAPH_CONSTANTS.MAX_RESULT - result.max_target) * GRAPH_CONSTANTS.dimensions.scale +
        GRAPH_CONSTANTS.dimensions.top;
      graphEl.appendChild(
        utils.makeSVG("rect", {
          x: GRAPH_CONSTANTS.dimensions.left,
          y: startingY,
          width: rectWidth,
          height: rectHeight,
          fill: `url('#targetResultPattern')`,
        })
      );
    }
  };

  /**
   *
   * @param {Object} props All parameters
   * @param {array} props.objects All data points shown in chart
   * @param {string} props.containerElementId ID of element containing chart element
   * @param {Object} props.options Options to override default chart options
   * @returns {void} Nothing-
   */
  this.drawStudentColChart = (props) => {
    const { objects, containerElementId, options: customOptions = {} } = props;

    const options = {
      chartArea: {
        width: "95%",
        height: "75%",
        left: GRAPH_CONSTANTS.dimensions.left,
        top: GRAPH_CONSTANTS.dimensions.top,
      },
      title: "",
      bar: { groupWidth: GRAPH_CONSTANTS.dimensions.barWidth },
      hAxis: {
        title: "",
        textStyle: {
          fontSize: GRAPH_CONSTANTS.dimensions.fontSize,
          bold: true,
        },
        gridlines: { color: "none", count: 0 },
      },
      vAxis: {
        title: "",
        ticks: [20, 30, 40, 50, 60, 70, 80, 90, 100],
        minValue: GRAPH_CONSTANTS.MIN_RESULT,
        maxValue: GRAPH_CONSTANTS.MAX_RESULT,
        gridlines: { color: "none" },
      },
      legend: { position: "none" },
      series: {
        0: {
          enableInteractivity: false,
        },
        1: {
          enableInteractivity: false,
        },
      },
      height: GRAPH_CONSTANTS.dimensions.height,
      ...customOptions,
    };

    let dataColumns = [["Subject", "Expected", "Actual", { role: "style" }]];
    for (let i = 0; i < objects.length; i++) {
      dataColumns.push([
        objects[i].subject,
        objects[i].expectation ? parseInt(objects[i].expectation) : 0,
        objects[i].valuation ? parseInt(objects[i].valuation) : 0,
        calculateColumnColor(objects[i]),
      ]);
    }

    google.charts.load("current", { packages: ["corechart", "bar"] });
    google.charts.setOnLoadCallback(drawMultiColChart);

    function drawMultiColChart() {
      const data = new google.visualization.arrayToDataTable(dataColumns);
      const container = document.getElementById(containerElementId);
      const chart = new google.visualization.ColumnChart(container);

      google.visualization.events.addListener(chart, "ready", function () {
        setColumnPositions(container);
        container
          .querySelectorAll(
            `svg > g:nth-of-type(1) > g:nth-of-type(1) > g > g.column-wrapper rect:not([width='${GRAPH_CONSTANTS.dimensions.barWidth}'])`
          )
          .forEach((g) => {
            g.addEventListener("mouseover", (e) => showColumnLabel(e));
            g.addEventListener("mouseout", hideColumnLabel);
          });
      });

      chart.draw(data, options);
    }

    function calculateColumnColor(object) {
      if (!object.valuation || !object.expectation) return GRAPH_CONSTANTS.colors.neutral;

      let score_difference = object.valuation - Math.round(object.expectation);
      if (score_difference > GRAPH_CONSTANTS.MIN_RESULT) {
        return GRAPH_CONSTANTS.colors.green;
      } else if (
        GRAPH_CONSTANTS.EXPECTATION_GAP <= score_difference &&
        score_difference <= GRAPH_CONSTANTS.MIN_RESULT
      ) {
        return GRAPH_CONSTANTS.colors.yellow;
      } else {
        return GRAPH_CONSTANTS.colors.red;
      }
    }

    function setColumnPositions(container) {
      const columnContainer = $(container).find("svg > g:first-of-type > g:first-of-type > g:first-of-type");
      const expColumns = $(columnContainer).find(`rect[fill="${GRAPH_CONSTANTS.colors.blue}"]`);
      const actColumns = $(columnContainer).find(`rect:not([fill="${GRAPH_CONSTANTS.colors.blue}"]`);
      const subjectLabels = $(container).find("svg > g:first-of-type > g:nth-of-type(3) g text");

      moveColumns(expColumns, actColumns, subjectLabels);
      addColumnCaps(expColumns, actColumns);
      recolorColumns(expColumns, actColumns);
      groupColumns(expColumns, actColumns);
    }

    function moveColumns(expCol, actCol, subjectLabels) {
      for (let i = 0; i < expCol.length; i++) {
        let newX = parseInt(expCol[i].getAttribute("x")) + GRAPH_CONSTANTS.dimensions.barWidth / 2;
        expCol[i].setAttribute("x", newX);
        expCol[i].setAttribute("width", GRAPH_CONSTANTS.dimensions.barWidth);
        actCol[i].setAttribute("x", newX);
        actCol[i].setAttribute("width", GRAPH_CONSTANTS.dimensions.barWidth);
        subjectLabels[i].setAttribute("x", newX + GRAPH_CONSTANTS.dimensions.barWidth / 2);
      }
    }

    function addColumnCaps(expCol, actCol) {
      let cap;
      for (let i = 0; i < expCol.length; i++) {
        cap = utils.makeSVG("rect", {
          width: GRAPH_CONSTANTS.dimensions.expCapWidth,
          height: GRAPH_CONSTANTS.dimensions.expCapHeight,
          fill: GRAPH_CONSTANTS.colors.orange,
        });
        cap.setAttribute("x", parseInt(expCol[i].getAttribute("x") - 5));
        cap.setAttribute("y", parseInt(expCol[i].getAttribute("y") - 3));
        actCol[i].after(cap);
      }
      for (let i = 0; i < actCol.length; i++) {
        cap = utils.makeSVG("rect", {
          width: GRAPH_CONSTANTS.dimensions.actCapWidth,
          height: GRAPH_CONSTANTS.dimensions.actCapHeight,
          fill: GRAPH_CONSTANTS.colors.grey,
        });
        cap.setAttribute("x", parseInt(actCol[i].getAttribute("x") - 3));
        cap.setAttribute("y", parseInt(actCol[i].getAttribute("y") - 1));
        actCol[i].after(cap);
      }
    }

    function recolorColumns(expCol, actCol) {
      for (let i = 0; i < expCol.length; i++) {
        expCol[i].setAttribute("fill", GRAPH_CONSTANTS.colors.white);
        expCol[i].setAttribute("stroke-width", 1);
        expCol[i].setAttribute("stroke", actCol[i].getAttribute("fill"));
      }
    }

    function groupColumns(expCol, actCol) {
      for (let i = 0; i < expCol.length; i++) {
        let xCoor = expCol[i].getAttribute("x");
        let parentContainer = expCol[i].parentElement;
        let orangeCap = parentContainer.querySelector(
          `rect[fill="${GRAPH_CONSTANTS.colors.orange}"][x="${xCoor - 5}"]`
        );

        let greyCap = parentContainer.querySelector(`rect[fill="${GRAPH_CONSTANTS.colors.grey}"][x="${xCoor - 3}"]`);
        let colWrapper = utils.makeSVG("g", {
          class: "column-wrapper",
          "data-subject": dataColumns[i + 1][0],
          "data-expected": dataColumns[i + 1][1],
          "data-actual": dataColumns[i + 1][2],
        });
        colWrapper.appendChild(expCol[i]);
        colWrapper.appendChild(actCol[i]);
        colWrapper.appendChild(orangeCap);
        colWrapper.appendChild(greyCap);
        parentContainer.appendChild(colWrapper);
      }
    }

    function showColumnLabel(e) {
      const hoverEl = e.currentTarget;
      const actualExpected = hoverEl.getAttribute("fill") == GRAPH_CONSTANTS.colors.grey;
      const columnEl = hoverEl.closest(".column-wrapper");
      const tooltipConstants = GRAPH_CONSTANTS.googleToolTip;
      const columnData = {
        subject: columnEl.dataset.subject,
        score: actualExpected ? columnEl.dataset.actual : columnEl.dataset.expected,
        labelText: actualExpected ? "Actual" : "Expected",
      };
      let [xCoor, yCoor] = [parseInt(hoverEl.getAttribute("x")), parseInt(hoverEl.getAttribute("y"))];
      const exceedY = yCoor > tooltipConstants.exceedYCoor;
      const exceedX = xCoor < tooltipConstants.exceedXCoor;
      xCoor = exceedX ? tooltipConstants.offsetX(xCoor, actualExpected) : xCoor;
      const path = exceedX
        ? tooltipConstants.rightPath(exceedY, xCoor, yCoor)
        : tooltipConstants.leftPath(exceedY, xCoor, yCoor);
      let columnLabelWrapper = utils.makeSVG("g", {
        class: tooltipConstants.className,
      });
      let columnLabel = utils.makeSVG("path", {
        d: path,
        stroke: GRAPH_CONSTANTS.colors.grey,
        "stroke-width": 1,
        fill: GRAPH_CONSTANTS.colors.white,
      });

      let subjectText = utils.makeTextNode(columnData.subject, {
        fill: GRAPH_CONSTANTS.colors.black,
        ...tooltipConstants.dimensions,
        y: tooltipConstants.dimensions.yCoor(yCoor, exceedY),
        x: tooltipConstants.dimensions.xCoor(xCoor, exceedX),
      });
      let scoreText = utils.makeTextNode(
        `${columnData.labelText} Result: ${
          actualExpected || columnData.score != GRAPH_CONSTANTS.MIN_RESULT ? columnData.score : "None"
        }`,
        {
          fill: GRAPH_CONSTANTS.colors.black,
          ...tooltipConstants.dimensions,
          y: tooltipConstants.dimensions.yCoor(yCoor, exceedY) + tooltipConstants.spacer,
          x: tooltipConstants.dimensions.xCoor(xCoor, exceedX),
        }
      );
      columnLabelWrapper.appendChild(columnLabel);
      columnLabelWrapper.appendChild(subjectText);
      columnLabelWrapper.appendChild(scoreText);
      columnEl.appendChild(columnLabelWrapper);
    }

    function hideColumnLabel() {
      const columnLabelWrapper = document.querySelector(
        `#${containerElementId} svg g.${GRAPH_CONSTANTS.googleToolTip.className}`
      );
      if (!columnLabelWrapper) return;
      columnLabelWrapper.remove();
    }
  };

  this.applyFileValidation = ({
    fileSelector,
    submitSelector,
    allowedFileSize = CONSTANTS.ALLOWED_FILESIZE,
    errorClassName = "upload_file_error_message",
  }) => {
    const filesizeMessage = "Unable to upload files with size larger than 2 megabytes.";

    const extensionErrorEl = $(`.${errorClassName}.file_error_extension`);
    const filesizeErrorEl = $(`.${errorClassName}.file_error_filesize`);

    $(fileSelector).on("change", function () {
      const filename = $(this).val();
      const filesizeValid = this.files[0] != undefined && this.files[0].size < allowedFileSize;
      const allowedExtensions = this.accept ? this.accept.split(",") : CONSTANTS.ALLOWED_EXTENSIONS;
      const extensionValid = allowedExtensions.some((ext) => filename.endsWith(ext));
      const extensionMessage = `
        Unable to upload files with format ${filename.split(".").pop()}.
        Allowed files (${allowedExtensions.map((e) => e.replace(/^\./, "")).join()})
      `;

      extensionErrorEl.addClass("t:hidden");
      filesizeErrorEl.addClass("t:hidden");

      if (!filename.length) return;

      if (extensionValid && filesizeValid) {
        submitSelector && $(submitSelector).removeAttr("disabled");
        $(this).parent().removeClass("invalid");
      } else {
        $(submitSelector).attr("disabled", "disabled");
        if (!extensionValid) extensionErrorEl.text(extensionMessage).removeClass("t:hidden");
        if (!filesizeValid) filesizeErrorEl.text(filesizeMessage).removeClass("t:hidden");
      }
    });
  };

  /**
   * recursive function to find nearest previous element
   * @param {HTMLElement} element
   * @returns HtmlElement
   */
  const findPreviousElement = (element) =>
    element && (element.previousElementSibling || findPreviousElement(element.parentElement));

  this.StickyTable = window.StickyTable = class {
    bind() {
      if (!this) return;

      const equalizeHeaderWidth = () => {
        if (this.headerWrapper && this.bodyWrapper)
          this.headerWrapper.style.width = this.bodyWrapper.offsetWidth + "px";
      }

      window.addEventListener("resize", () => equalizeHeaderWidth(), false);

      this.stickyTableElement = document.querySelector(`.sticky-table`);
      if (!this.stickyTableElement) return;

      this.headerWrapper = this.stickyTableElement.querySelector(".table-header-wrapper");
      this.bodyWrapper = this.stickyTableElement.querySelector(".table-body-wrapper");

      // add listener to tr mouseover and mouseout to make first sticky column hoverable
      for (let tr of this.bodyWrapper.querySelectorAll("table.table-hover tbody tr")) {
        const stickyColumn = tr.querySelector(".sticky-column");
        if (stickyColumn) {
          tr.addEventListener("mouseover", () => stickyColumn.style.setProperty("background-color", "#f1f3f7f2"));
          tr.addEventListener("mouseout", () => stickyColumn.style.setProperty("background-color", "#fff"));
        }
      }

      // observer to find out when needed to stick header on top
      const observerEl = findPreviousElement(this.stickyTableElement);
      if (observerEl) {
        let observer = new IntersectionObserver((entries) => {
          if (this.headerWrapper) {
            const theObserverEntry = entries[0];

            if (window.innerHeight > this.stickyTableElement.offsetHeight ||
              window.innerHeight < this.bodyWrapper.offsetHeight) {

              const isStickyHeaderEnabled = !theObserverEntry.isIntersecting;
              if (isStickyHeaderEnabled) {
                this.headerWrapper.classList.add("t:fixed", "t:top-0", "t:z-10");
                this.bodyWrapper.style.marginTop = `${this.headerWrapper.getBoundingClientRect().height}px`;
                equalizeHeaderWidth();
              } else {
                this.headerWrapper.classList.remove("t:fixed", "t:top-0", "t:z-10");
                this.bodyWrapper.style.marginTop = "0";
              }
            }
          }
        });
        observer.observe(observerEl);
      }

      // change the Header scroll position according to the Table scroll
      const isScrollListenerAdded = this.bodyWrapper.hasAttribute("listener");
      if (!isScrollListenerAdded) {
        this.bodyWrapper.addEventListener("scroll", () => {
          this.headerWrapper.querySelector("table").style.marginLeft = -1 * this.bodyWrapper.scrollLeft + `px`;
        });
        this.bodyWrapper.setAttribute("listener", "true");
      }
    }
  };

  /** ******************************************************************************
   * General method to call different types of http request
   * with ability of show messages
   *
   * @param {method} string REST methods GET/PUT/POST/DELETE...
   * @param {data} object data as a object
   * @param {url} string api url
   * @returns
   */
  this.callApi = ({ method = "get", data, url, options }) => {
    const { isAlertsOn } = { isAlertsOn: { success: false, fail: false }, ...options };
    const requestOptions = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method,
    };
    if (method !== "get") {
      const AUTH_TOKEN = document.querySelector("meta[name=csrf-token]").getAttribute("content");
      const updatedData = { ...data, authenticity_token: AUTH_TOKEN };
      requestOptions.body = JSON.stringify(updatedData);
    }

    return new Promise((resolve, reject) =>
      fetch(url, requestOptions)
        .then((res) => {
          if (res.ok) {
            if (isAlertsOn.success) this.showSnackbar({ text: CONSTANTS.ALERTS.SUCCESS });
            return res.status === 200 ? resolve(res.json()) : resolve(true);
          }
          if (isAlertsOn.fail) this.showSnackbar({ type: CONSTANTS.ALERT_TYPES.error, text: res.statusText });
          return reject(res.statusText);
        })
        .catch((err) => {
          if (isAlertsOn.fail)
            this.showSnackbar({ type: CONSTANTS.ALERT_TYPES.error, text: err.responseText || err.statusText });
          console.error(err);
          return reject(err);
        })
    );
  };

  /** ******************************************************************************
   * @param {HTMLElement} el Specified select element
   * @param {Array} data An array of data that provides text & value for generated options
   */
  this.generateSelectOptions = (el, data, ordinalize = false) => {
    if (!el) return;
    if (Array.isArray(data) && data.length) {
      data.forEach((value) => $(el).append(new Option(ordinalize ? `${ordinal(value)} Year` : value, value)));
    }
  };

  this.chartCustomLabels = {
    id: "customLabels",
    afterDraw: (chart) => {
      const {
        ctx,
        scales: { x, y },
      } = chart;

      ctx.save();
      chart.data.labels.forEach((l, i) => {
        const index = l.indexOf("-");
        const lastIndex = l.indexOf("-");

        const year = l.substr(0, index - 1);
        const date = l.substr(index + 1, lastIndex + 1);

        const xAxis = x.getPixelForValue(l, i);
        ctx.font = "bold 12px Nunito Sans";
        ctx.fillText(year, xAxis - 23, y.bottom + 17);

        ctx.font = "10px Nunito Sans";
        ctx.fillText(date, xAxis - 25, y.bottom + 34);
      });

      ctx.restore();
    },
  };

  /** ******************************************************************************
   * @param {String} wrapperSelector Specified wrapper element
   * @param {String} formId Specified filter form element
   * @param {Function} buildChart Injected function with specifics to build google.charts
   */

  this.bindExpandRowEvent = (wrapperSelector, formId, buildChart) => {
    let chartContainerId, chartRow;

    if (!$(wrapperSelector) || !$(wrapperSelector).length) return;

    $(document).on("click", "table tr.expand-row", function (e) {
      if (!$(e.target).is("a")) {
        chartRow = $(this).closest("tr").next();
        chartContainerId = $(chartRow).find(".chartContainer").attr("id");

        if (!$(chartRow).hasClass("has-chart")) {
          var formData = Array.from(new FormData(document.querySelector(formId)).entries()).map(([name, value]) => ({ name, value }));
          const chartLegendWidth = $(".chart-legend").length ? $(".chart-legend").width() : 0;
          $("#" + chartContainerId).width(
            $(".scroll-holder").width() - $(".student_names").width() - chartLegendWidth - 100
          );

          buildChart(chartContainerId, formData);
        }
        $(chartRow).toggleClass("active");
      }
    });
  };

  this.setTableHeight = () => {
    const tableBodyWrapper = $(".table-body-wrapper");
    if (!tableBodyWrapper) return;

    tableBodyWrapper.floatingScroll();

    tableBodyWrapper.on("scroll", function () {
      $(this).find(".chartContainer").css("margin-left", $(this).scrollLeft());
    });

    const stickyTable = new this.StickyTable();
    stickyTable.bind();
  };
})();
